module.exports = __webpack_public_path__ + "img/minus_black.22edd504.svg";